<app-modal
  #modal
  [modalConfig]="modalConfig"
  (isDismissing)="reset()"
  (isClosing)="reset()">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    [disabled]="uploadSaving"
    (click)="modal.dismiss()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="container">
    <div class="row">
      <div class="col-12 my-3">
        <input
          #uploadFileInput
          type="file"
          style="display: none"
          multiple
          accept=".pdf,.csv,.doc,.docx,.xls,.xlsx,.html,.txt,.md,.gif,.jpeg,.jpg,.png"
          (change)="onUploadFileChange($event)" />
        <div
          class="upload-dropzone p-3 text-center rounded-1"
          [class.upload-dropzone--active]="uploadDropzoneActive"
          [class.upload-dropzone--disabled]="uploadSaving"
          (click)="uploadFileInput.click()"
          (dragover)="$event.preventDefault(); uploadDropzoneActive = true"
          (dragleave)="$event.preventDefault(); uploadDropzoneActive = false"
          (dragend)="$event.preventDefault(); uploadDropzoneActive = false"
          (drop)="handleUploadFileDrop($event)">
          <p class="color-dark-gray fw-bold mb-2">
            Click here or drag files here to upload
          </p>
          <div class="btn btn-tertiary">
            <i class="bi bi-upload"></i>
          </div>
        </div>

        <div
          *ngIf="uploadErrorMessage"
          class="alert alert-danger text-start mt-3 mb-0 d-flex justify-content-between"
          role="alert">
          {{ uploadErrorMessage }}
          <button
            type="button"
            class="btn-close"
            (click)="uploadErrorMessage = ''"
            data-bs-dismiss="alert"
            aria-label="Close"></button>
        </div>
        <div *ngIf="stagedFiles.length > 0" class="file-list mt-2">
          <div
            *ngFor="let staged of stagedFiles; let i = index"
            class="d-flex flex-column border-bottom border-black-subtle py-2">
            <div
              class="d-flex flex-row justify-content-between align-items-center">
              <div class="file-name">
                <i
                  class="bi {{
                    getFileIcon(staged.file.name)
                  }} color-tertiary fs-21 me-1 d-inline-block"></i>
                <span title="{{ staged.file.name }}">{{
                  staged.file.name
                }}</span>
              </div>
              <button
                *ngIf="staged.status === 'pending'"
                class="btn-delete"
                ngbTooltip="Remove"
                aria-label="Remove file"
                (click)="removeStagedFile(i)">
                <i class="bi fs-21 bi-trash"></i>
              </button>
              <i
                *ngIf="staged.status === 'done'"
                class="bi bi-check-lg text-success fs-21"></i>
              <i
                *ngIf="staged.status === 'error'"
                class="bi bi-x-circle text-danger fs-21"></i>
            </div>
            <ngb-progressbar
              *ngIf="staged.status === 'uploading' || staged.status === 'done'"
              class="mt-1"
              [value]="staged.progress"
              [animated]="staged.status === 'uploading'"></ngb-progressbar>
            <small *ngIf="staged.status === 'error'" class="text-danger mt-1">
              {{ staged.errorMsg }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-between" footerContent>
    <button
      type="button"
      class="btn btn-reset"
      [disabled]="uploadSaving"
      (click)="modal.dismiss()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!stagedFiles.length || uploadSaving"
      (click)="saveUploadFiles()">
      <span
        *ngIf="uploadSaving"
        class="spinner-border spinner-border-sm me-1"
        role="status"
        aria-hidden="true"></span>
      {{ uploadSaving ? "Uploading..." : "Upload" }}
    </button>
  </div>
</app-modal>
